import { css, keyframes } from "@emotion/react";
import { CSSInterpolation } from "@emotion/serialize";

export const ENTER_EASE = "cubic-bezier(0.16, 0.84, 0.24, 1)";
export const EXIT_EASE = "cubic-bezier(0.62, 0.02, 0.36, 1)";

export const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const contentIn = keyframes`
  from { transform: translateY(-5px); }
  to { transform: translateY(0); }
`;

export const contentOut = keyframes`
  from { transform: translateY(0); }
  to { transform: translateY(-5px); }
`;

export const iconIn = keyframes`
  from { transform: scale(0.94); }
  to { transform: scale(1); }
`;

/** Draws a `pathLength="1"` stroke, as used by `CheckCircleDrawIcon`. */
export const strokeDraw = keyframes`
  from { stroke-dashoffset: 1; }
  to { stroke-dashoffset: 0; }
`;

export const motionSafe = (
  template: TemplateStringsArray,
  ...values: CSSInterpolation[]
) => css`
  animation: ${css(template, ...values)};

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 1ms;
    animation-delay: 0ms;
  }
`;
